import { FC, type JSX } from 'react'
import { ILinkComponentProps } from '../Navbar/Navbar'
import './Dropdown.css'

export interface IDropdownItem {
  name: string | JSX.Element
  href?: string
  itemOnClick?: () => void
}

export interface IDropdownProps {
  dropdownItems: IDropdownItem[]
  LinkComponent: FC<ILinkComponentProps>
  addClass?: string
  selectedItemIndex?: number
}

const Dropdown = ({
  dropdownItems,
  LinkComponent,
  selectedItemIndex,
  addClass = '',
}: IDropdownProps) => {
  const getDropdownItem = (item: IDropdownItem) => {
    if (item.href) {
      return <LinkComponent href={item.href}>{item.name}</LinkComponent>
    } else if (item.itemOnClick) {
      return (
        <button onClick={item.itemOnClick} data-testid="dropdown-button">
          {item.name}
        </button>
      )
    } else return null
  }

  return (
    <div className={`Dropdown ${addClass}`} data-testid="dropdown">
      <ul>
        {dropdownItems.map((item, index) => (
          <li
            key={`dropdown-item-${index}`}
            className={
              index === selectedItemIndex ? 'Dropdown__item--selected' : ''
            }
          >
            {getDropdownItem(item)}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Dropdown
